// ===================================================================
// KAIXO - PlanBadge: indicador del plan actual con días restantes
// ===================================================================
// Pequeño componente pegajoso para mostrar en el Header o Sidebar.
// Click → abre PlansModal.
// ===================================================================

import React, { useState } from 'react';
import usePlan from '../../hooks/usePlan';
import PlansModal from './PlansModal';

const COLORS = {
    FREE: '#9E9E9E',
    STARTER: '#F5A000',
    GROWTH: '#2A6EFF',
    PRO: '#C9A227',
    SCALE: '#111111'
};

function PlanBadge({ compact = false }) {
    const [showModal, setShowModal] = useState(false);
    const { tier, daysLeft, isExpired, loading } = usePlan();

    if (loading || !tier) return null;
    const color = COLORS[tier] || COLORS.FREE;

    return (
        <>
            <button
                onClick={() => setShowModal(true)}
                className="kaixo-plan-badge"
                style={{
                    background: color,
                    color: '#fff',
                    border: 'none',
                    padding: compact ? '4px 10px' : '6px 12px',
                    borderRadius: 14,
                    fontSize: compact ? 11 : 12,
                    fontWeight: 700,
                    cursor: 'pointer',
                    letterSpacing: '0.3px',
                    textTransform: 'uppercase',
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 6,
                    transition: 'transform 0.15s'
                }}
                title="Gestionar plan"
            >
                <span>{tier}</span>
                {!compact && tier !== 'FREE' && daysLeft !== null && (
                    <span style={{
                        opacity: 0.8,
                        fontSize: 10,
                        fontWeight: 500,
                        textTransform: 'none'
                    }}>
                        · {isExpired ? 'expirado' : `${daysLeft}d`}
                    </span>
                )}
            </button>
            {showModal && <PlansModal onClose={() => setShowModal(false)} />}
        </>
    );
}

export default PlanBadge;
